module.exports = __webpack_public_path__ + "static/img/bg2.0017772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg2.jpg
// module id = +tGy
// module chunks = 0